import Swiper from 'swiper/bundle';

document.addEventListener("DOMContentLoaded", function () {
    const scope = document.querySelector('.home-industries');

    const industryNames = scope.querySelectorAll('.industry-name');
    const backgrounds = scope.querySelectorAll('.industry-bg');
    const industryInfos = scope.querySelectorAll('.industry-info');
    const prevArrow = scope.querySelector('.industry-nav.prev');
    const nextArrow = scope.querySelector('.industry-nav.next');

    let currentIndex = 0;

    // Set the first industry as visible
    if (industryNames.length > 0) {
        const firstIndustryName = industryNames[0].getAttribute('data-industry-name');
        scope.querySelector(`.industry-bg[data-industry-name="${firstIndustryName}"]`).classList.remove('hidden');
        scope.querySelector(`.industry-info[data-industry-name="${firstIndustryName}"]`).classList.remove('hidden');
        industryNames[0].classList.add('active');
    }

    function showIndustry(index) {
        // Hide all backgrounds and industry infos
        backgrounds.forEach(bg => bg.classList.add('hidden'));
        industryInfos.forEach(info => {
            info.classList.add('hidden');
            info.classList.remove('active');
        });
        industryNames.forEach(name => name.classList.remove('active'));

        // Show the corresponding background and industry info
        const industryName = industryNames[index].getAttribute('data-industry-name');
        scope.querySelector(`.industry-bg[data-industry-name="${industryName}"]`).classList.remove('hidden');
        const activeInfo = scope.querySelector(`.industry-info[data-industry-name="${industryName}"]`);
        activeInfo.classList.remove('hidden');
        activeInfo.classList.add('active');
        industryNames[index].classList.add('active');
    }

    industryNames.forEach((name, index) => {
        name.addEventListener('click', function () {
            currentIndex = index;
            showIndustry(currentIndex);
        });
    });

    prevArrow.addEventListener('click', function () {
        currentIndex = (currentIndex > 0) ? currentIndex - 1 : industryNames.length - 1;
        showIndustry(currentIndex);
    });

    nextArrow.addEventListener('click', function () {
        currentIndex = (currentIndex < industryNames.length - 1) ? currentIndex + 1 : 0;
        showIndustry(currentIndex);
    });

    // Industry icon marquee using Swiper.js
    const swiper = new Swiper('.industry-icon-marquee', {
        slidesPerView: 4,
        spaceBetween: 15,
        loop: true,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
        },
        speed: 5000,
        allowTouchMove: false,
        breakpoints: {
            // when window width is <= 360px
            360: {
                slidesPerView: 5,
                spaceBetween: 15,
            },
            // when window width is <= 468
            468: {
                slidesPerView: 6,
                spaceBetween: 20,
            },
            // when window width is <= 567
            567: {
                slidesPerView: 7,
                spaceBetween: 20,
            },
            // when window width is <= 768px
            768: {
                slidesPerView: 7,
                spaceBetween: 25,
            }
        }
    });
});